export function AdminCards (pConfig)
{
  return (
  {
    name : 'EditorToolbarCardsLocalConfig',

    Groups :
    [
      {
        name : 'BigSizeButtonsCards',
        visible : true
      },

      {
        name : 'HistoryActionsPublic',
        visible : true
      },

      {
        name : 'TextDecorationCardsPublic',
        visible : true
      },

      {
        name : 'TextAlignPublic',
        visible : true
      },

      {
        name : 'FontForeColorsPublic',
        visible : true
      },

      {
        name : 'BlockStylesCardsPublic',
        visible : true,
        lineBreak : true
      }
    ]
  });
}